import { PGA_COACH_ERROR_TEXT } from 'lib/styles/pga-coach-pill-colors'

// Stripe Elements `appearance` for the redesigned review step. The Payment
// Element keeps rendering its own method tabs (Card, Bank, ... depending on
// what the payment intent allows); these rules restyle them to the rounded 12px
// look of the other private booking inputs. Colors mirror the
// `offeringsRefresh` navy and the neutrals in the group event redesign sheet.
// Keep this a module-level constant: `Elements` warns when `options` change.
const NAVY = '#00234B'
const TEXT = '#172024'
const FIELD_BORDER = '#D9DCE1'
const CARD_BORDER = '#E6E8EC'

export const STRIPE_APPEARANCE = {
  theme: 'stripe',
  labels: 'above',
  variables: {
    borderRadius: '12px',
    colorPrimary: NAVY,
    colorText: TEXT,
    colorDanger: PGA_COACH_ERROR_TEXT,
    spacingUnit: '4px',
    gridRowSpacing: '16px',
    gridColumnSpacing: '12px',
  },
  rules: {
    '.Tab': {
      border: `1px solid ${CARD_BORDER}`,
      borderRadius: '12px',
      boxShadow: 'none',
      padding: '14px 16px',
    },
    '.Tab:hover': {
      borderColor: NAVY,
      color: TEXT,
    },
    '.Tab--selected, .Tab--selected:hover, .Tab--selected:focus': {
      borderColor: NAVY,
      boxShadow: `0 0 0 1px ${NAVY}`,
      color: NAVY,
    },
    '.TabIcon--selected, .TabIcon--selected:hover': {
      fill: NAVY,
    },
    '.TabLabel--selected, .TabLabel--selected:hover': {
      color: NAVY,
    },
    '.Input': {
      border: `1px solid ${FIELD_BORDER}`,
      borderRadius: '12px',
      boxShadow: 'none',
      padding: '14px 16px',
    },
    '.Input:focus': {
      borderColor: NAVY,
      boxShadow: `0 0 0 1px ${NAVY}`,
    },
    '.Input--invalid': {
      borderColor: PGA_COACH_ERROR_TEXT,
      boxShadow: `0 0 0 1px ${PGA_COACH_ERROR_TEXT}`,
    },
    '.Label': {
      color: TEXT,
      fontSize: '14px',
      fontWeight: '600',
    },
  },
}
